import { Authenticator } from "@mindlercare/auth-ui";
import { Illustration, theme } from "@mindlercare/ui-web";
import { useFlag } from "@mindlercare/unleash-client";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { styled } from "styled-components";
import { Typography } from "../typography";
import { useImplementedFeature } from "core/selectors/app";

export const Login = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const passkeyEnabled = useFlag("PASSKEYS");
  const [_, invalidateImplementedFeatures] = useImplementedFeature(null);
  return (
    <Wrapper>
      <div data-testid="loginView">
        <LogoImg
          src={`${window?.location?.origin}/img/mindler_logo.svg`}
          alt="Mindler logo"
        />
        <div>
          <Authenticator
            passkeyEnabled={passkeyEnabled}
            useMarketSelector
            onChangeMarket={(market) => {
              localStorage.setItem("mindlercare:market", market.codeISO2);
              invalidateImplementedFeatures();
            }}
            onLogin={() => navigate("/")}
          />
          <Typography insensitive variant="body-x-small" color="GRAY">
            {t("ISO_27001_TEXT")}
          </Typography>
        </div>
      </div>
      <div>
        <div>
          <Typography variant="h1" insensitive>
            {t("LOGIN_WELCOME")}
          </Typography>
          <Typography variant="h3" insensitive>
            {t("LOGIN_APPLICATION_NAME")}
          </Typography>
        </div>
        <Illustration.PsychologistAndPatient />
      </div>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);

  & > div {
    padding: calc(${theme.PADDING.XL} * 3);
    display: grid;
    place-content: center;
    grid-template-rows: auto 1fr;

    & > div {
      display: flex;
      flex-direction: column;
      justify-content: center;
      gap: 32px;

      & > div {
        justify-content: start;
        min-height: auto;
      }
    }
  }

  & > div:nth-of-type(2) {
    height: 100vh;
    display: flex;
    gap: 48px;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background-color: ${theme.COLORS.TERTIARY_LIGHT};

    & > div {
      display: flex;
      flex-direction: column;
      gap: 10px;
      justify-content: center;
      align-items: center;
    }
  }
`;

const LogoImg = styled.img`
  width: 12rem;
`;
